import { render, staticRenderFns } from "./AudienceList.vue?vue&type=template&id=ec4c01b8&"
import script from "./AudienceList.vue?vue&type=script&lang=js&"
export * from "./AudienceList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports